<template>
	<div class="widget-test-page">
		<div v-if="loading" class="test-page-loading test-page-loading--cool">
			<div class="test-page-loading__spinner"></div>
			<p class="test-page-loading__text">Loading...</p>
		</div>

		<div v-else class="widget-test-page__content">
			<div class="layout-placeholder layout-header">
				<div class="layout-link-list">
					<a
						v-for="link in blockLinks"
						:key="'header-' + link.id"
						class="layout-link"
						:href="link.href"
						:target="link.newTab ? '_blank' : '_self'"
						:rel="link.newTab ? 'noopener noreferrer' : undefined"
					>{{ link.label }}</a>
				</div>
			</div>
			<div class="layout-placeholder layout-hero">
				<div class="layout-link-list">
					<a
						v-for="link in blockLinks"
						:key="'hero-' + link.id"
						class="layout-link"
						:href="link.href"
						:target="link.newTab ? '_blank' : '_self'"
						:rel="link.newTab ? 'noopener noreferrer' : undefined"
					>{{ link.label }}</a>
				</div>
			</div>
			<div class="layout-main">
				<div class="layout-placeholder layout-sidebar">
					<div class="layout-link-list">
						<a
							v-for="link in blockLinks"
							:key="'sidebar-' + link.id"
							class="layout-link"
							:href="link.href"
							:target="link.newTab ? '_blank' : '_self'"
							:rel="link.newTab ? 'noopener noreferrer' : undefined"
						>{{ link.label }}</a>
					</div>
				</div>
				<div class="layout-placeholder layout-content">
					<div class="layout-link-list">
						<a
							v-for="link in blockLinks"
							:key="'content-' + link.id"
							class="layout-link"
							:href="link.href"
							:target="link.newTab ? '_blank' : '_self'"
							:rel="link.newTab ? 'noopener noreferrer' : undefined"
						>{{ link.label }}</a>
					</div>
				</div>
			</div>
			<div class="layout-placeholder layout-section-a">
				<div class="layout-link-list">
					<a
						v-for="link in blockLinks"
						:key="'section-a-' + link.id"
						class="layout-link"
						:href="link.href"
						:target="link.newTab ? '_blank' : '_self'"
						:rel="link.newTab ? 'noopener noreferrer' : undefined"
					>{{ link.label }}</a>
				</div>
			</div>
			<div class="layout-placeholder layout-section-b">
				<div class="layout-link-list">
					<a
						v-for="link in blockLinks"
						:key="'section-b-' + link.id"
						class="layout-link"
						:href="link.href"
						:target="link.newTab ? '_blank' : '_self'"
						:rel="link.newTab ? 'noopener noreferrer' : undefined"
					>{{ link.label }}</a>
				</div>
			</div>

			<div ref="widgetBottom" class="widget-bottom">
				<div v-if="widgetLoading && currentPartKey" class="widget-area-loading">
					<div class="widget-area-loading__spinner"></div>
					<p class="widget-area-loading__text">Loading widget…</p>
				</div>
				<div v-else id="contrimetrics_weight">
					<div v-if="currentWidgetHtml" v-html="currentWidgetHtml"></div>
					<p v-else class="widget-empty-tip">请通过 ?part=1~4 加载对应站点 widget</p>
				</div>
			</div>

			<div
				v-for="group in postWidgetGroups"
				:key="group.id"
				class="post-widget-group"
				:style="{ backgroundColor: group.bg }"
			>
				<div class="post-widget-group__title">{{ group.title }}</div>

				<div v-if="group.type === 'cards'" class="post-widget-cards">
					<div
						v-for="card in group.cards"
						:key="card.id"
						class="post-widget-card"
						:style="{ backgroundColor: card.bg }"
					>
						<p class="post-widget-card__label">{{ card.label }}</p>
						<div class="layout-link-list post-widget-card__links">
							<a
								v-for="link in blockLinks.slice(0, 4)"
								:key="group.id + '-card-' + card.id + '-' + link.id"
								class="layout-link layout-link--dark"
								:href="link.href"
								:target="link.newTab ? '_blank' : '_self'"
								:rel="link.newTab ? 'noopener noreferrer' : undefined"
							>{{ link.label }}</a>
						</div>
					</div>
				</div>

				<div v-else-if="group.type === 'list'" class="post-widget-list">
					<a
						v-for="link in blockLinks"
						:key="group.id + '-list-' + link.id"
						class="post-widget-list__item layout-link layout-link--dark"
						:href="link.href"
						:target="link.newTab ? '_blank' : '_self'"
						:rel="link.newTab ? 'noopener noreferrer' : undefined"
					>{{ link.label }}</a>
				</div>

				<div v-else-if="group.type === 'tags'" class="post-widget-tags">
					<a
						v-for="tag in group.tags"
						:key="group.id + '-tag-' + tag.id"
						class="post-widget-tag"
						:href="tag.href"
						:target="tag.newTab ? '_blank' : '_self'"
						:rel="tag.newTab ? 'noopener noreferrer' : undefined"
					>{{ tag.label }}</a>
				</div>

				<div v-else-if="group.type === 'footer'" class="post-widget-footer">
					<span class="post-widget-footer__text">{{ group.description }}</span>
					<div class="layout-link-list post-widget-footer__links">
						<a
							v-for="link in blockLinks.slice(0, 6)"
							:key="group.id + '-footer-' + link.id"
							class="layout-link layout-link--dark"
							:href="link.href"
							:target="link.newTab ? '_blank' : '_self'"
							:rel="link.newTab ? 'noopener noreferrer' : undefined"
						>{{ link.label }}</a>
					</div>
				</div>
			</div>

			<div
				v-if="partContentHeight"
				class="part-content-block"
				:style="{ height: partContentHeight + 'px', backgroundColor: partContentColor }"
			>
				<p class="part-content-block__label">Part {{ partValue }} · {{ partContentHeight }}px</p>
			</div>
		</div>
	</div>
</template>

<script>
import { widgetPartsHtml, widgetPartsCss, widgetPartsMeta } from './widgetParts/widgetPartsData';

const blockLinks = [
	{ id: 1, label: 'Home · 当前页', href: '/home', newTab: false },
	{ id: 2, label: 'Articles · 新标签', href: '/articles', newTab: true },
	{ id: 3, label: 'Our Story · 当前页', href: '/our-story', newTab: false },
	{ id: 4, label: 'AI · 新标签', href: '/ai', newTab: true },
	{ id: 5, label: 'Clients · 当前页', href: '/clients', newTab: false },
	{ id: 6, label: 'Price · 新标签', href: '/price', newTab: true },
	{ id: 7, label: 'Metrics · 当前页', href: '/metrics', newTab: false },
	{ id: 8, label: 'Help · 新标签', href: '/help', newTab: true },
	{ id: 9, label: 'Terms · 当前页', href: '/terms', newTab: false },
	{ id: 10, label: 'Contact Us · 新标签', href: '/contact-us', newTab: true },
];

const postWidgetGroups = [
	{
		id: 'post-cards',
		title: 'Post Widget · Cards',
		type: 'cards',
		bg: '#ebf5fb',
		cards: [
			{ id: 1, label: 'Card A', bg: '#5dade2' },
			{ id: 2, label: 'Card B', bg: '#48c9b0' },
			{ id: 3, label: 'Card C', bg: '#af7ac5' },
		],
	},
	{
		id: 'post-list',
		title: 'Post Widget · Link List',
		type: 'list',
		bg: '#f4ecf7',
	},
	{
		id: 'post-tags',
		title: 'Post Widget · Tags',
		type: 'tags',
		bg: '#e8f8f5',
		tags: [
			{ id: 1, label: 'Home', href: '/home', newTab: false },
			{ id: 2, label: 'Download', href: '/download', newTab: true },
			{ id: 3, label: 'Contrimetric', href: '/contrimetric', newTab: false },
			{ id: 4, label: 'Recheck AI', href: '/recheck-ai', newTab: true },
			{ id: 5, label: 'Privacy', href: '/privacy', newTab: false },
			{ id: 6, label: 'GA Baseline', href: '/internal/sys/analytics/ga-baseline/layout-shell-no-widget-embed', newTab: true },
		],
	},
	{
		id: 'post-footer',
		title: 'Post Widget · Footer Row',
		type: 'footer',
		bg: '#eaecee',
		description: 'Supplementary footer links below widget embed area.',
	},
];

// part=1~4 预设高度（500-1500 范围内），其它 part 随机
const partContentPresets = {
	1: 780,
	2: 1320,
	3: 960,
	4: 1180,
};

function getPartContentHeight(part) {
	const preset = partContentPresets[part];
	if (preset) return preset;
	return 500 + Math.floor(Math.random() * 1001);
}

function getPartContentColor(part) {
	if (part === '1') return '#aed6f1';
	if (part === '2') return '#abebc6';
	if (part === '3') return '#f9e79f';
	if (part === '4') return '#d7bde2';
	return '#d5d8dc';
}

const WIDGET_STYLE_ID = 'widget-layout-test-part-style';

const widgetPartWebsites = {
	1: 'https://contrimetric.com/internal/sys/analytics/ga-baseline/layout-shell-no-widget-embed?part=1&utm_source=contrimetric.com&utm_medium=referral&utm_campaign=contrimetric_widget',
	2: 'https://contrimetric.com/internal/sys/analytics/ga-baseline/layout-shell-no-widget-embed?part=2&utm_source=contrimetric.com&utm_medium=referral&utm_campaign=contrimetric_widget',
	3: 'https://contrimetric.com/internal/sys/analytics/ga-baseline/layout-shell-no-widget-embed?part=3&utm_source=contrimetric.com&utm_medium=referral&utm_campaign=contrimetric_widget',
	4: 'https://contrimetric.com/internal/sys/analytics/ga-baseline/layout-shell-no-widget-embed?part=4&utm_source=contrimetric.com&utm_medium=referral&utm_campaign=contrimetric_widget',
};

function applyWidgetWebsite(html, partKey) {
	const website = widgetPartWebsites[partKey];
	if (!website || !html) return html;
	return html.replace(/data-website="[^"]*"/g, `data-website="${website}"`);
}

// jjssxzz.cn 等站点用 flexible rem（html ≈119px），嵌入本页（16px）后 inline rem 会极小
const WIDGET_PART_REM_ROOT = {
	1: 118.857142857, // 13px / 0.109375rem
};

function normalizeWidgetRemUnits(content, partKey) {
	const remRoot = WIDGET_PART_REM_ROOT[partKey];
	if (!remRoot || !content) return content;
	return content.replace(/([\d.]+)rem/g, (_, rem) => {
		const px = Math.round(parseFloat(rem) * remRoot * 100) / 100;
		return `${px}px`;
	});
}

function prepareWidgetHtml(html, partKey) {
	return normalizeWidgetRemUnits(applyWidgetWebsite(html, partKey), partKey);
}

function prepareWidgetCss(css, partKey) {
	return normalizeWidgetRemUnits(css, partKey);
}

export default {
	name: 'WidgetLayoutTest',
	computed: {
		currentPartKey() {
			const part = this.$route.query.part;
			if (part == null || part === '') return '';
			const key = String(part);
			return widgetPartsHtml[key] ? key : '';
		},
		currentWidgetHtml() {
			if (!this.currentPartKey) return '';
			return prepareWidgetHtml(widgetPartsHtml[this.currentPartKey], this.currentPartKey);
		},
		currentWidgetCss() {
			if (!this.currentPartKey) return '';
			return prepareWidgetCss(widgetPartsCss[this.currentPartKey], this.currentPartKey);
		},
	},
	data() {
		return {
			loading: true,
			loadingTimer: null,
			widgetLoading: false,
			widgetLoadingTimer: null,
			blockLinks,
			postWidgetGroups,
			widgetPartsMeta,
			partValue: '',
			partContentHeight: 0,
			partContentColor: '#d5d8dc',
		};
	},
	created() {
		this.initPartContent();
	},
	watch: {
		'$route.query.part'() {
			this.initPartContent();
			if (!this.loading) {
				this.startWidgetLoading();
			}
		},
		currentWidgetCss(css) {
			if (!this.widgetLoading) {
				this.applyWidgetCss(css);
			}
		},
		currentWidgetHtml() {
			if (!this.loading && !this.widgetLoading) {
				this.$nextTick(() => {
					this.initWidgetItems();
				});
			}
		},
	},
	mounted() {
		const delay = 2500 + Math.random() * 1000;
		this.loadingTimer = setTimeout(() => {
			this.loading = false;
			this.$nextTick(() => {
				this.startWidgetLoading();
			});
		}, delay);
	},
	beforeDestroy() {
		if (this.loadingTimer) {
			clearTimeout(this.loadingTimer);
		}
		if (this.widgetLoadingTimer) {
			clearTimeout(this.widgetLoadingTimer);
		}
		this.removeWidgetCss();
	},
	methods: {
		applyWidgetCss(css) {
			if (!css) {
				this.removeWidgetCss();
				return;
			}
			let el = document.getElementById(WIDGET_STYLE_ID);
			if (!el) {
				el = document.createElement('style');
				el.id = WIDGET_STYLE_ID;
				document.head.appendChild(el);
			}
			el.textContent = css;
		},
		removeWidgetCss() {
			const el = document.getElementById(WIDGET_STYLE_ID);
			if (el) el.remove();
		},
		initPartContent() {
			const part = this.$route.query.part;
			const partKey = part != null && part !== '' ? String(part) : '';
			this.partValue = partKey || 'none';
			this.partContentHeight = partKey
				? getPartContentHeight(Number(partKey))
				: 0;
			this.partContentColor = getPartContentColor(partKey);
		},
		startWidgetLoading() {
			if (this.widgetLoadingTimer) {
				clearTimeout(this.widgetLoadingTimer);
				this.widgetLoadingTimer = null;
			}
			this.removeWidgetCss();

			if (!this.currentPartKey) {
				this.widgetLoading = false;
				return;
			}

			this.widgetLoading = true;
			const delay = 2000 + Math.random() * 1000;
			this.widgetLoadingTimer = setTimeout(() => {
				this.widgetLoading = false;
				this.widgetLoadingTimer = null;
				this.$nextTick(() => {
					this.applyWidgetCss(this.currentWidgetCss);
					this.initWidgetItems();
				});
			}, delay);
		},
		initWidgetItems() {
			const container = this.$refs.widgetBottom;
			if (!container) return;

			Array.from(container.querySelectorAll('.contrimetrics_weight_item')).forEach((item) => {
				const titleEl = item.getElementsByClassName('contrimetrics_weight_item_right')[0];
				if (!titleEl) return;

				const website = item.getAttribute('data-website') || '';
				const doi = item.getAttribute('data-doi') || '';
				const url = website || (doi ? `https://doi.org/${doi}` : '');
				if (!url) return;

				titleEl.setAttribute('title', titleEl.textContent);
				titleEl.style.cursor = 'pointer';
				titleEl.onclick = () => {
					window.open(url, '_blank', 'noopener,noreferrer');
				};
			});
		},
	},
};
</script>

<style scoped>
.widget-test-page {
	min-height: 1700px;
	width: 100%;
}

.widget-test-page__content {
	min-height: 1700px;
	width: 100%;
}

.test-page-loading {
	position: fixed;
	inset: 0;
	z-index: 9999;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	background: rgba(255, 255, 255, 0.96);
	pointer-events: all;
	cursor: wait;
	user-select: none;
}

.test-page-loading__spinner {
	width: 48px;
	height: 48px;
	border: 4px solid rgba(52, 152, 219, 0.2);
	border-top-color: #3498db;
	border-radius: 50%;
	animation: test-page-spin 0.8s linear infinite;
}

.test-page-loading--cool .test-page-loading__text {
	color: #2c3e50;
}

.test-page-loading__text {
	margin-top: 16px;
	font-size: 15px;
	font-weight: 500;
	letter-spacing: 0.02em;
	animation: test-page-pulse 1.2s ease-in-out infinite;
}

@keyframes test-page-spin {
	to {
		transform: rotate(360deg);
	}
}

@keyframes test-page-pulse {
	0%,
	100% {
		opacity: 0.45;
	}

	50% {
		opacity: 1;
	}
}

.layout-placeholder {
	display: flex;
	align-items: flex-start;
	justify-content: flex-start;
	color: rgba(255, 255, 255, 0.85);
	font-size: 18px;
	font-weight: 600;
	overflow: hidden;
}

.layout-link-list {
	display: flex;
	flex-wrap: wrap;
	gap: 8px 14px;
	padding: 12px 16px;
	width: 100%;
	height: 100%;
	align-content: flex-start;
	box-sizing: border-box;
	overflow: auto;
}

.layout-link {
	color: #fff;
	font-size: 13px;
	font-weight: 500;
	line-height: 1.4;
	text-decoration: underline;
	text-underline-offset: 2px;
	white-space: nowrap;
}

.layout-link:hover {
	opacity: 0.85;
}

.layout-header {
	height: 120px;
	background-color: #2c3e50;
}

.layout-hero {
	height: 380px;
	background-color: #3498db;
	margin-top: 8px;
}

.layout-main {
	display: flex;
	gap: 8px;
	margin-top: 8px;
	height: 520px;
}

.layout-sidebar {
	flex: 0 0 280px;
	background-color: #9b59b6;
}

.layout-content {
	flex: 1;
	background-color: #1abc9c;
}

.layout-section-a {
	height: 320px;
	background-color: #e67e22;
	margin-top: 8px;
}

.layout-section-b {
	height: 280px;
	background-color: #34495e;
	margin-top: 8px;
}

.widget-bottom {
	margin-top: 24px;
	padding: 0 16px 40px;
}

.widget-area-loading {
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	min-height: 240px;
	padding: 48px 16px;
	background: rgba(236, 240, 241, 0.6);
	border-radius: 8px;
	cursor: wait;
	user-select: none;
}

.widget-area-loading__spinner {
	width: 40px;
	height: 40px;
	border: 3px solid rgba(52, 152, 219, 0.2);
	border-top-color: #3498db;
	border-radius: 50%;
	animation: test-page-spin 0.8s linear infinite;
}

.widget-area-loading__text {
	margin: 14px 0 0;
	font-size: 14px;
	font-weight: 500;
	color: #2c3e50;
	letter-spacing: 0.02em;
	animation: test-page-pulse 1.2s ease-in-out infinite;
}

.widget-empty-tip {
	margin: 0;
	padding: 24px 0;
	text-align: center;
	color: #7f8c8d;
	font-size: 14px;
}

.post-widget-group {
	margin: 16px 16px 0;
	padding: 20px;
	border-radius: 8px;
}

.post-widget-group:last-child {
	margin-bottom: 40px;
}

.post-widget-group__title {
	margin-bottom: 14px;
	font-size: 16px;
	font-weight: 700;
	color: #2c3e50;
}

.post-widget-cards {
	display: flex;
	gap: 12px;
	flex-wrap: wrap;
}

.post-widget-card {
	flex: 1 1 220px;
	min-height: 140px;
	padding: 14px;
	border-radius: 6px;
}

.post-widget-card__label {
	margin: 0 0 10px;
	font-size: 14px;
	font-weight: 600;
	color: #fff;
}

.post-widget-card__links {
	padding: 0;
	height: auto;
	overflow: visible;
}

.layout-link--dark {
	color: #1a5276;
}

.post-widget-card .layout-link--dark {
	color: #fff;
}

.post-widget-list {
	display: flex;
	flex-direction: column;
	gap: 8px;
}

.post-widget-list__item {
	display: block;
	font-size: 14px;
}

.post-widget-tags {
	display: flex;
	flex-wrap: wrap;
	gap: 10px;
}

.post-widget-tag {
	display: inline-block;
	padding: 6px 14px;
	border-radius: 999px;
	background: #fff;
	color: #117a65;
	font-size: 13px;
	font-weight: 500;
	text-decoration: none;
	border: 1px solid #a3e4d7;
}

.post-widget-tag:hover {
	background: #d5f5e3;
}

.post-widget-footer {
	display: flex;
	flex-direction: column;
	gap: 12px;
}

.post-widget-footer__text {
	font-size: 14px;
	color: #566573;
	line-height: 1.5;
}

.post-widget-footer__links {
	padding: 0;
	height: auto;
	overflow: visible;
}

.part-content-block {
	margin: 16px 16px 0;
	border-radius: 8px;
	display: flex;
	align-items: flex-start;
	justify-content: center;
	padding-top: 24px;
}

.part-content-block__label {
	margin: 0;
	font-size: 15px;
	font-weight: 600;
	color: #2c3e50;
}
</style>
